"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseApiProd = exports.baseApi = exports.createBaseApi = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const config_1 = require("./config");
const getLocalData = (name) => {
    if (localStorage.getItem(name)) {
        return localStorage.getItem(name);
    }
};
// Create our baseQuery instance
const baseQuery = (config) => (0, react_1.fetchBaseQuery)({
    baseUrl: getLocalData('api-path') ? getLocalData('api-path') : config === null || config === void 0 ? void 0 : config.baseUrl,
    prepareHeaders: (headers, { getState }) => {
        var _a;
        // By default, if we have a token in the store, let's use that for authenticated requests
        const token = getLocalData('api-token') ? getLocalData('api-token') : (_a = getState().auth) === null || _a === void 0 ? void 0 : _a.token;
        if (token) {
            headers.set('authentication', `Bearer ${token}`);
        }
        return headers;
    },
});
const baseQueryWithRetry = (config) => (0, react_1.retry)(baseQuery(config), { maxRetries: 1 });
/**
 * Create a base API to inject endpoints into elsewhere.
 * Components using this API should import from the injected site,
 * in order to get the appropriate types,
 * and to ensure that the file injecting the endpoints is loaded
 */
const createBaseApi = (config) => {
    return (0, react_1.createApi)({
        /**
         * `reducerPath` is optional and will not be required by most users.
         * This is useful if you have multiple API definitions,
         * e.g. where each has a different domain, with no interaction between endpoints.
         * Otherwise, a single API definition should be used in order to support tag invalidation,
         * among other features
         */
        reducerPath: (config === null || config === void 0 ? void 0 : config.reducerPath) || 'alphaPrepApi',
        /**
         * A bare bones base query would just be `baseQuery: fetchBaseQuery({ baseUrl: '/' })`
         */
        baseQuery: baseQueryWithRetry(config),
        /**
         * Tag types must be defined in the original API definition
         * for any tags that would be provided by injected endpoints
         */
        tagTypes: [],
        /**
         * This api has endpoints injected in adjacent files,
         * which is why no endpoints are shown below.
         * If you want all endpoints defined in the same file, they could be included here instead
         */
        endpoints: () => ({}),
    });
};
exports.createBaseApi = createBaseApi;
exports.baseApi = (0, exports.createBaseApi)(config_1.devConfig);
exports.baseApiProd = (0, exports.createBaseApi)(config_1.prodConfig);
// export const enhancedApi = api.enhanceEndpoints({
//   endpoints: () => ({
//     getPost: () => 'test',
//   }),
// })
